import { FC, KeyboardEvent } from 'react';

import { Asset } from 'src/interfaces/assets.types';
import { fixMissingHttps } from 'src/utils/url.utils';

import './apps-section-item.scss';

interface AppsSectionItemProps {
  itemAsset: Asset;
}

export const AppsSectionItem: FC<AppsSectionItemProps> = ({ itemAsset }) => {
  const { name, metadata } = itemAsset;
  const { dashboard } = metadata;

  const handleItemKeyDown = (e: KeyboardEvent) => {
    if (e.key === ' ') {
      e.preventDefault();

      const eventTarget = e.target as HTMLAnchorElement;

      eventTarget.click();
    }
  };

  return (
    <li className="apps-section-item">
      <a
        className="apps-section-item__link"
        href={fixMissingHttps(dashboard.appUrl)}
        target="_blank"
        rel="noreferrer"
        onKeyDown={handleItemKeyDown}
      >
        <img
          className="apps-section-item__thumbnail"
          src={dashboard.thumbnailUrl}
          alt=""
        />
        <span className="apps-section-item__name">{name}</span>
      </a>
    </li>
  );
};
